"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bellLabel = bellLabel;
function bellLabel(status, count) {
    if (status === "loading")
        return "Notifications, loading";
    if (status === "error")
        return "Notifications could not be loaded";
    if (count === 1)
        return "1 notification";
    return count > 0 ? `${count} notifications` : "No notifications";
}
//# sourceMappingURL=bellStatus.js.map